import { getEnvValue } from 'configs/app/utils';

import { ContractAddressName } from './enums/contract-address-name';

export const contractAddressMapping = {
  [ContractAddressName.NftBidOffset]: getEnvValue('NEXT_PUBLIC_NFT_BID_OFFSET'),
  [ContractAddressName.NftRedeemV3Stamp]: getEnvValue('NEXT_PUBLIC_NFT_REDEEM_V3_STAMP'),
} as { [name: string]: string };
